const jsonHelper = async (seriesId) => {
    const url = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      throw new Error(error.message);
    }
  };
  
  export {jsonHelper};  // Default export
  